const page_schema = {
	"tiers": [
		{
			"name": "Sample Input",
			"type": "checkbox",
			"id": "sample-inputs",
			"class_name": "tags",
			"child_name": "sample-input",
			"options": [
				{
					"name": "Purified DNA",
					"id": "purified-dna"
				},
				{
					"name": "Purified RNA",
					"id": "purified-rna"
				},
				{
					"name": "Cells",
					"id": "cells"
				},
				{
					"name": "Blood",
					"id": "blood"
				},
				{
					"name": "Tissue",
					"id": "tissue"
				},
				{
					"name": "FFPE",
					"id": "ffpe"
				},
				{
					"name": "cfDNA",
					"id": "cfdna"
				},
			]
		},
		{
			"name": "Downstream Analysis",
			"type": "checkbox",
			"id": "downstream-analysis",
			"class_name": "tags",
			"child_name": "downstream-analysi",
			"options": [
				{
					"name": "PCR/qPCR",
					"id": "pcr-qpcr"
				},
				{
					"name": "Illumina EPIC Array",
					"id": "illumina-epic-array"
				},
				{
					"name": "IDT XGen Methyl-Seq",
					"id": "idt-xgen-methyl-seq"
				},
				{
					"name": "IDT XGen Adaptase",
					"id": "idt-xgen-adaptase"
				},
				{
					"name": "Agilent SureSelect MethylSeq",
					"id": "agilent-sureselect-methylseq"
				},
				{
					"name": "NGS Library Prep",
					"id": "ngs-library-prep"
				},
			]
		},
		{
			"name": "Format",
			"type": "checkbox",
			"id": "formats",
			"class_name": "tags",
			"child_name": "format",
			"options": [
				{
					"name": "Columns",
					"id": "columns"
				},
				{
					"name": "96-Well Plate",
					"id": "96-well-plate"
				},
				{
					"name": "Beads",
					"id": "beads"
				},
			]
		},
		{
			"name": "Feature",
			"type": "checkbox",
			"id": "features",
			"class_name": "tags",
			"child_name": "feature",
			"options": [
				{
					"name": "CE-IVD",
					"id": "ce-ivd"
				},
				{
					"name": "High-Throughput",
					"id": "high-throughput"
				},
				{
					"name": "Low Input",
					"id": "low-input"
				},
			]
		},
		{
			"name": "d-none",
			"type": "checkbox",
			"id": "d-none",
			"class_name": "tags",
			"child_name": "d-none",
			"options": [
				{
					"name": "bisulfite-conversion",
					"id": "bisulfite-conversion",
				},
				{
					"name": "Bisulfite Sequencing Library Preparation",
					"id": "bisulfite-sequencing-library-preparation"
				},
				{
					"name": "Low Input",
					"id": "low-input"
				},
			]
		},
	],
	"filters": [],
	"products": {
		"EZ DNA Methylation-Startup Kit": {
			"title": "EZ DNA Methylation-Startup Kit",
			"catalogNumbers": "D5024",
			"description": "The EZ DNA Methylation-Start-up kit is an all-in-one kit contains reagents for bisulfite conversion of DNA without the need for purification, methylated human DNA with control primers, and a robust hot-start PCR polymerase that is specifically formulated for bisulfite-converted DNA.",
			"handle": "/products/ez-dna-methylation-startup-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5024_EZ_20DNA_20Methylation-Startup_20Kit.png?v=1628532403&width=600",
			"generalIndex": "998",
			"id": "ez-dna-methylation-startup-kit",
			"tags": [
				"purified-dna",
				"cells",
				"blood",
				"tissue",
				"ffpe",
				"cfdna",
				"pcr-qpcr",
				"columns",
				"bisulfite-conversion",
			],
			filters: []
		},
		"EZ RNA Methylation Kit": {
			"title": "EZ RNA Methylation Kit",
			"catalogNumbers": "R5001, R5002",
			"description": "The EZ RNA Methylation Kit features rapid and reliable bisulfite conversion of cytosines in RNA for methylation analysis. The kit streamlines the three-step process for complete conversion of cytosine in into uracil.",
			"handle": "/products/ez-rna-methylation-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R5001_EZ-RNA-Methylation-Kit.jpg?v=1628532401&width=600",
			"generalIndex": "998",
			"id": "ez-rna-methylation-kit",
			"tags": [
				"purified-rna",
				"columns",
			],
			filters: []
		},
		"Zymo-Seq Trio WGBS Library Kit": {
			"title": "Zymo-Seq Trio WGBS Library Kit",
			"catalogNumbers": "D5462, D5463",
			"description": "The Zymo-Seq Trio WGBS Library Kit offers an optimized and reliable workflow for whole genome bisulfite sequencing (WGBS) library preparation from cell-free DNA (cfDNA), FFPE DNA, and gDNA.",
			"handle": "/products/zymo-seq-trio-wgbs-library-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5462_Zymo-Seq-Cell-Free-DNA-WGBS-Library-Kit.jpg?v=1642623540&width=600",
			"generalIndex": "998",
			"id": "zymo-seq-trio-wgbs-library-kit",
			"tags": [
				"purified-dna",
				"ffpe",
				"cfdna",
				"ngs-library-prep",
				"columns",
				"low-input",
				"bisulfite-sequencing-library-preparation",
			],
			filters: []
		},
		"Zymo-Seq WGBS Library Kit": {
			"title": "Zymo-Seq WGBS Library Kit",
			"catalogNumbers": "D5465",
			"description": "Zymo-Seq WGBS Library Kit is the only kit available for whole genome bisulfite (WGBS) library preparation in a single tube. The Kit incorporates tagmentation technology to eliminate the tedious fragmentation, enzymatic, and clean-up steps required by conventional, ligation-based library preparation methods. Reproducible genome coverage from any species (>90% of CpG sites detected in mammalian samples)",
			"handle": "/products/zymo-seq-wgbs-library-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d5465-zymo_seq_wgbs_library_kit.jpg?v=1628632445&width=600",
			"generalIndex": "998",
			"id": "zymo-seq-wgbs-library-kit",
			"tags": [
				"purified-dna",
				"ngs-library-prep",
				"columns",
				"low-input",
				"bisulfite-sequencing-library-preparation",
			],
			filters: []
		},
		"Zymo-Seq RRBS Library Kit": {
			"title": "Zymo-Seq RRBS Library Kit",
			"catalogNumbers": "D5460, D5461",
			"description": "Zymo-Seq RRBS Library Kit is an all-in-one RRBS library prep kit that generates NGS libraries with a simplified workflow for the classic method Reduced Representation Bisulfite Sequencing (RRBS). This all-in-one RRBS library prep kit allows for DNA methylation profiling at single-nucleotide resolution in CpG-rich regions of the genome.",
			"handle": "/products/zymo-seq-rrbs-library-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d5460_ez_dna_methylation_rrbs_library_prep_kit_3045e660-6901-4f39-bdf2-0a00421995b9.png?v=1628706203&width=600",
			"generalIndex": "998",
			"id": "zymo-seq-rrbs-library-kit",
			"tags": [
				"purified-dna",
				"ngs-library-prep",
				"columns",
				"low-input",
				"bisulfite-sequencing-library-preparation",
			],
			filters: []
		},
		"Pico Methyl-Seq Library Prep Kit": {
			"title": "Pico Methyl-Seq Library Prep Kit",
			"catalogNumbers": "D5455, D5456",
			"description": "The Pico Methyl-Seq Library Prep Kit provides a streamlined workflow for making WGBS libraries. Input DNA is randomly fragmented during the initial bisulfite treatment step followed by three rounds of amplification with uniquely designed primers. The procedure can accommodate as little as 10 pg input DNA (including that derived from FFPE samples), making it ideal for methylation analysis of precious, limited, and target-enriched samples.",
			"handle": "/products/pico-methyl-seq-library-prep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d5456_pico-methyl-seq-library-prep-kit_1.jpg?v=1628532385&width=600",
			"generalIndex": "998",
			"id": "pico-methyl-seq-library-prep-kit",
			"tags": [
				"purified-dna",
				"ngs-library-prep",
				"columns",
				"low-input",
				"bisulfite-sequencing-library-preparation",
			],
			filters: []
		},
		"ZymoTaq Premix": {
			"title": "ZymoTaq Premix",
			"catalogNumbers": "E2003, E2004",
			"description": "ZymoTaq PreMix is supplied as a 2X concentrated “master mix” containing all the reagents needed to perform “hot start” PCR. The inclusion of a heat-activated, thermal-stable DNA polymerase reduces primer dimer and non-specific product formation that can occur when performing conventional PCR. This unique product is specifically designed for the amplification of bisulfite-treated DNA for methylation detection.",
			"handle": "/products/zymotaq-premix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2003_ZymoTaq-PreMix.jpg?v=1628532368&width=600",
			"generalIndex": "998",
			"id": "zymotaq-premix",
			"tags": [
				"purified-dna",
				"ffpe",
				"cfdna",
				"pcr-qpcr",
				"low-input",
			],
			filters: []
		},
		"ZymoTaq DNA Polymerase": {
			"title": "ZymoTaq DNA Polymerase",
			"catalogNumbers": "E2001, E2002",
			"description": "ZymoTaq DNA Polymerase contains all the reagents needed to perform “hot-start” PCR. The inclusion of a heat-activated, thermostable DNA polymerase reduces primer dimer and nonspecific product formation that can occur during PCR. This unique product is specifically designed for the amplification of bisulfite-treated DNA for methylation detection, but is applicable for conventional PCR. ",
			"handle": "/products/zymotaq-dna-polymerase",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2001_ZymoTaq-Polymerase.jpg?v=1628532372&width=600",
			"generalIndex": "998",
			"id": "zymotaq-dna-polymerase",
			"tags": [
				"purified-dna",
				"ffpe",
				"cfdna",
				"pcr-qpcr",
				"low-input",
			],
			filters: []
		},
		"ZymoTaq qPCR Premix": {
			"title": "ZymoTaq qPCR Premix",
			"catalogNumbers": "E2054, E2055",
			"description": "ZymoTaq qPCR PreMix contains all the reagents needed to perform quantitative PCR and other molecular downstream analysis such as high-resolution melt (HRM) analysis of DNA methylation and other general real-time PCR assays. This premix features a hot-start DNA polymerase and buffer system optimized for the amplification of bisulfite-treated DNA. It also includes an intense dsDNA-specific fluorescent dye, SYTO 9, for sensitive real-time DNA quantification.",
			"handle": "/products/zymotaq-qpcr-premix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2054_ZymoTaq-qPCR-Premix.jpg?v=1628532408&width=600",
			"generalIndex": "998",
			"id": "zymotaq-qpcr-premix",
			"tags": [
				"purified-dna",
				"ffpe",
				"cfdna",
				"pcr-qpcr",
			],
			filters: []
		},
		"Zymo-Seq UDI Primer Sets": {
			"title": "Zymo-Seq UDI Primer Sets",
			"catalogNumbers": "D3008, D3096, D3097, D3098",
			"description": "The Zymo-Seq UDI Primer Sets contain pre-mixed Unique Dual Index (UDI) primers that can be used to barcode any library containing TruSeq<sup>®</sup> adapters. Indexes in the Zymo-Seq UDI Primer Set (Indexes 1-12) are dispensed in 1.5 mL tubes (Cat. No. D3008), and the Zymo-Seq UDI Primer Plate (Indexes 1-96) are dispensed in single-use foil-sealed 96-well plates (Ca. No. D3096). Indexed libraries are compatible with any Illumina<sup>®</sup> sequencer. ",
			"handle": "/products/dsdna-shearase-plus",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d3008_d3096_zymo-seq_udi_primer_set_Indexes_1-96.png?v=1628532421&width=600",
			"generalIndex": "998",
			"id": "dsdna-shearase-plus",
			"tags": [
				"ngs-library-prep",
				"high-throughput",
				"low-input",
			],
			filters: []
		},
		"EZ DNA Methylation-Lightning Kit": {
			"title": "EZ DNA Methylation-Lightning Kit",
			"catalogNumbers": "D5030, D5031, D5030T, D5030-E, D5031-E",
			"description": "The EZ DNA Methylation-Lightning Kit can rapidly bisulfite convert and purify DNA in less than 1.5 hours. A ready-to-use conversion reagent streamlines this process – simply add the reagent directly to the sample and incubate. Desulphonation and clean-up of the converted DNA is performed on a spin-column, allowing an elution volume as low as 10 µl. The kit achieves high conversion efficiency of unmodified cytosines into uracil, ensuring accurate downstream methylation analysis.",
			"handle": "/collections/ez-dna-methylation-lightning-kits/products/ez-dna-methylation-lightning-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5030_EZ-DNA-Methylation-Lightning-Kit-Column.jpg?v=1632263439&width=600",
			"generalIndex": "998",
			"id": "ez-dna-methylation-lightning-kit",
			"tags": [
				"purified-dna",
				"cfdna",
				"pcr-qpcr",
				"columns",
				"low-input",
				"bisulfite-conversion",
			],
			filters: []
		},
		"EZ-96 DNA Methylation-Lightning Kit": {
			"title": "EZ-96 DNA Methylation-Lightning Kit",
			"catalogNumbers": "D5032, D5033",
			"description": "The EZ-96 DNA Methylation-Lightning Kit is a rapid, high-throughput (96-well) bisulfite conversion kit for DNA methylation analysis. The streamlined workflow features ready-to-use Lightning Conversion Reagent and a combined DNA denaturation and bisulfite conversion process. Desulphonation and clean-up of the converted DNA is performed using a unique 96-well spin-plate. With the Deep-Well Kit (Cat. D5033), samples can be eluted in as little as 15 µl. High yield, converted DNA is ideal for PCR, array, and Next-Generation sequencing, etc.",
			"handle": "/products/ez-96-dna-methylation-lightning-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5032_EZ-96-DAN-Methylation-Lightning-Kit-Shallow-Well_8a88a685-b5c4-48bd-a549-d70384045426.jpg?v=1632268109&width=600",
			"generalIndex": "998",
			"id": "ez-96-dna-methylation-lightning-kit",
			"tags": [
				"purified-dna",
				"cfdna",
				"pcr-qpcr",
				"96-well-plate",
				"high-throughput",
				"low-input",
			],
			filters: []
		},
		"EZ DNA Methylation-Lightning Automation Kit": {
			"title": "EZ DNA Methylation-Lightning Automation Kit",
			"catalogNumbers": "D5049",
			"description": "The EZ DNA Methylation-Lightning Automation Kit is a high-throughput DNA bisulfite conversion kit designed for streamlining automation workflows.",
			"handle": "/products/ez-dna-methylation-lightning-automation-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d5049-ez_dna_methylation_lightning_automation_kit.jpg?v=1633408988&width=600",
			"generalIndex": "998",
			"id": "ez-dna-methylation-lightning-automation-kit",
			"tags": [
				"purified-dna",
				"cfdna",
				"pcr-qpcr",
				"illumina-epic-array",
				"beads",
				"bisulfite-conversion",
			],
			filters: []
		},
		"EZ-96 DNA Methylation-Lightning MagPrep": {
			"title": "EZ-96 DNA Methylation-Lightning MagPrep",
			"catalogNumbers": "D5046, D5047, D5046-E, D5047-E",
			"description": "The EZ DNA Methylation-Lightning magbead based Kits are the fastest magnetic bead-based DNA bisulfite conversion kit for high-throughput and automated methylation analysis. No preparation is necessary with the ready-to-use conversion reagent - simply add this unique reagent to a DNA sample and incubate the reaction for about one hour. Desulphonation and clean-up of the converted DNA is performed while bound to the MagBinding Beads. This magnetic bead-based bisulfite conversion kit produces the highest yields of bisulfite-converted DNA that is ideal for PCR, arrays, library preps, and Next-Generation sequencing.",
			"handle": "/products/ez-96-dna-methylation-lightning-magprep",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5046-E_EZ-96-DNA-Methylation-Lightning-MagPrep_4e8e4b9b-86d1-4c0f-bce8-abe88db4135a.jpg?v=1676054453&width=600",
			"generalIndex": "998",
			"id": "ez-96-dna-methylation-lightning-magprep",
			"tags": [
				"purified-dna",
				"pcr-qpcr",
				"illumina-epic-array",
				"beads",
				"high-throughput",
				"low-input",
			],
			filters: []
		},
		"EZ DNA Methylation-Direct Kit": {
			"title": "EZ DNA Methylation-Direct Kit",
			"catalogNumbers": "D5020, D5021",
			"description": "The EZ DNA Methylation-Direct kit is a bisulfite conversion kit that features reliable and complete DNA bisulfite conversion directly from blood, tissue, and cells without the prerequisite for DNA purification. The increased sensitivity of this bisulfite conversion kit makes it possible to amplify bisulfite-converted DNA from as few as 10 cells or 50 pg DNA. Recovered bisulfite-converted DNA is ideal for downstream analyses including PCR amplification, endonuclease digestion, sequencing, microarrays, etc.",
			"handle": "/collections/ez-dna-methylation-direct-kits/products/ez-dna-methylation-direct-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5020_EZ-DNA-Methylation-Direct-Kit-Column.jpg?v=1628532405&width=600",
			"generalIndex": "998",
			"id": "ez-dna-methylation-direct-kit",
			"tags": [
				"purified-dna",
				"cells",
				"blood",
				"tissue",
				"ffpe",
				"cfdna",
				"pcr-qpcr",
				"idt-xgen-adaptase",
				"columns",
				"low-input",
				"bisulfite-conversion",
			],
			filters: []
		},
		"EZ-96 DNA Methylation-Direct Kit": {
			"title": "EZ-96 DNA Methylation-Direct Kit",
			"catalogNumbers": "D5023, D5022",
			"description": "The EZ-96 DNA Methylation-Direct Kit is a 96-well bisulfite conversion kit that features reliable and complete DNA bisulfite conversion directly from blood, tissue, and cells without the prerequisite for DNA purification. The increased sensitivity of this 96-well bisulfite conversion kit makes it possible to amplify bisulfite-converted DNA from as few as 10 cells or 50 pg DNA. Recovered bisulfite-converted DNA is ideal for PCR amplification for downstream analyses including restriction endonuclease digestion, sequencing, microarrays, etc.",
			"handle": "/collections/ez-dna-methylation-direct-kits/products/ez-96-dna-methylation-direct-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5022_EZ-96-DNA-Methylatoin-Direct-Kit-Shallow-Well.jpg?v=1628532411&width=600",
			"generalIndex": "998",
			"id": "ez-96-dna-methylation-direct-kit",
			"tags": [
				"purified-dna",
				"cells",
				"blood",
				"tissue",
				"ffpe",
				"cfdna",
				"96-well-plate",
				"high-throughput",
				"low-input",
			],
			filters: []
		},
		"EZ-96 DNA Methylation-Direct MagPrep": {
			"title": "EZ-96 DNA Methylation-Direct MagPrep",
			"catalogNumbers": "D5045, D5044",
			"description": "The EZ-96 DNA Methylation-Direct MagPrep is a magnetic bead-based bisulfite conversion kit that allows simple and reliable DNA bisulfite conversion directly from blood, tissue, and cells without the prerequisite for DNA purification. The increased sensitivity of this magnetic bead-based bisulfite conversion kit makes it possible to amplify bisulfite-converted DNA from as few as 10 cells or 50 pg DNA. These innovations have been coupled to a magnetic bead-based clean-up for high-throughput methylation analysis. Desulphonation and clean-up of the converted DNA is performed while bound to the MagBinding Beads. This magnetic bead based bisulfite conversion kit has been designed to minimize template degradation, loss of DNA during treatment and clean-up, and to provide complete conversion of unmethylated cytosines. Recovered DNA is ideal for downstream analyses, including PCR amplification, endonuclease digestion, sequencing, microarrays, etc.",
			"handle": "/collections/ez-dna-methylation-direct-kits/products/ez-96-dna-methylation-direct-magprep",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5044-EZ-96-Methylation-Lightning-Direct.jpg?v=1628532392&width=600",
			"generalIndex": "998",
			"id": "ez-96-dna-methylation-direct-magprep",
			"tags": [
				"purified-dna",
				"cells",
				"blood",
				"tissue",
				"ffpe",
				"cfdna",
				"pcr-qpcr",
				"idt-xgen-adaptase",
				"beads",
				"high-throughput",
				"low-input",
			],
			filters: []
		},
		"EZ DNA Methylation Kit": {
			"title": "EZ DNA Methylation Kit",
			"catalogNumbers": "D5001, D5002",
			"description": "The EZ DNA Methylation Kit features a simplified procedure that streamlines bisulfite treatment of DNA. This kit is the original bisulfite conversion kit from Zymo Research. The EZ DNA Methylation Kit is based on the three-step reaction that takes place between cytosine and sodium bisulfite during which cytosine is converted into uracil. Innovative desulphonation technologies eliminate otherwise cumbersome precipitations. The kit is designed to reduce template degradation and minimize DNA loss during treatment and clean-up, while ensuring complete conversion of the DNA. Purified, converted DNA is ideal for downstream analyses including library preparation for Next-generation sequencing, PCR amplification, endonuclease digestion, sequencing, microarrays, etc. The EZ DNA Methylation Kit is recommended for use with Illumina Infinium MethylationEPIC BeadChip array.",
			"handle": "/collections/ez-dna-methylation-kits/products/ez-dna-methylation-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5001_EZ-DNA-Methylation-Kit.jpg?v=1628532396&width=600",
			"generalIndex": "998",
			"id": "ez-dna-methylation-kit",
			"tags": [
				"purified-dna",
				"pcr-qpcr",
				"illumina-epic-array",
				"columns",
				"bisulfite-conversion",
			],
			filters: []
		},
		"EZ-96 DNA Methylation Kit": {
			"title": "EZ-96 DNA Methylation Kit",
			"catalogNumbers": "D5003, D5004",
			"description": "The EZ-96 DNA Methylation Kits are bisulfite conversion kits that feature a high-throughput (96-well spin-plate), simplified procedure that streamlines bisulfite conversion of DNA. Cytosines undergo a three-step reaction with sodium bisulfite during which the cytosine is converted into uracil. The innovative in-column desulphonation technology eliminates otherwise cumbersome precipitations. The kit is designed to reduce template degradation and minimize DNA loss during treatment and clean-up, while ensuring complete conversion of the DNA. Purified, converted DNA is ideal for downstream analyses including PCR amplification, endonuclease digestion, sequencing, microarrays, etc.",
			"handle": "/collections/ez-dna-methylation-kits/products/ez-96-dna-methylation-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5003-EZ-96-DNA-Methylation-Kit---shallow-well.png?v=1628532406&width=600",
			"generalIndex": "998",
			"id": "ez-96-dna-methylation-kit",
			"tags": [
				"purified-dna",
				"pcr-qpcr",
				"96-well-plate",
				"high-throughput",
			],
			filters: []
		},
		"EZ-96 DNA Methylation MagPrep": {
			"title": "EZ-96 DNA Methylation MagPrep",
			"catalogNumbers": "D5040, D5041",
			"description": "The EZ-96 DNA Methylation MagPrep is a bisulfite conversion kit that features a high-throughput (96-well), simplified procedure that streamlines bisulfite conversion of DNA. The kit is based on the three-step reaction that takes place between cytosine and sodium bisulfite during which cytosine is converted into uracil. Desulphonation and clean-up of the converted DNA is performed while bound to the MagBinding Beads. The kit is designed to reduce template degradation and minimize DNA loss during treatment and clean-up, while ensuring complete conversion of the DNA. Purified, converted DNA is ideal for downstream analyses including PCR amplification, endonuclease digestion, sequencing, microarrays, etc.",
			"handle": "/collections/ez-dna-methylation-kits/products/ez-96-dna-methylation-magprep",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5040_EZ-96-DNA-Methylation-MagPrep-Kit.jpg?v=1628532410&width=600",
			"generalIndex": "998",
			"id": "ez-96-dna-methylation-magprep",
			"tags": [
				"purified-dna",
				"pcr-qpcr",
				"beads",
				"high-throughput",
			],
			filters: []
		},
		"EZ DNA Methylation-Gold Kit": {
			"title": "EZ DNA Methylation-Gold Kit",
			"catalogNumbers": "D5005, D5006",
			"description": "The EZ DNA Methylation-Gold Kit is a refinement of our popular EZ DNA Methylation kit and uses heat denaturation instead of chemical denaturation of the input DNA. This allows for the denaturation and bisulfite conversion steps to be consolidated into one step, leading to a much-reduced incubation time. Recovered bisulfite-converted DNA is ideal for PCR amplification for downstream analyses including endonuclease digestion, sequencing, microarrays, etc.",
			"handle": "/collections/ez-dna-methylation-gold-kits/products/ez-dna-methylation-gold-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5005_EZ-DNA-Methylation-Gold-Kit.jpg?v=1628532410&width=600",
			"generalIndex": "998",
			"id": "ez-dna-methylation-gold-kit",
			"tags": [
				"purified-dna",
				"pcr-qpcr",
				"idt-xgen-methyl-seq",
				"agilent-sureselect-methylseq",
				"columns",
				"bisulfite-conversion",
			],
			filters: []
		},
		"EZ-96 DNA Methylation-Gold Kit": {
			"title": "EZ-96 DNA Methylation-Gold Kit",
			"catalogNumbers": "D5007, D5008",
			"description": "The EZ-96 DNA Methylation-Gold Kit allows high-throughput (96-well spin-plate) conversion of unmethylated cytosines into uracil in less than 3 hours. Our optimized bisulfite chemistry combines heat denaturation and bisulfite conversion of input DNA to reduce incubation time and ensure conversion rates >99%. Recovered bisulfite-converted DNA is ideal for PCR amplification for downstream analyses including endonuclease digestion, sequencing, microarrays, etc.",
			"handle": "/collections/ez-dna-methylation-gold-kits/products/ez-96-dna-methylation-gold-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5007_EZ-DNA-Methylation-Gold-Kit.jpg?v=1628532400&width=600",
			"generalIndex": "998",
			"id": "ez-96-dna-methylation-gold-kit",
			"tags": [
				"purified-dna",
				"pcr-qpcr",
				"idt-xgen-methyl-seq",
				"agilent-sureselect-methylseq",
				"96-well-plate",
				"high-throughput",
			],
			filters: []
		},
		"EZ-96 DNA Methylation-Gold MagPrep": {
			"title": "EZ-96 DNA Methylation-Gold MagPrep",
			"catalogNumbers": "D5042, D5043",
			"description": "The EZ-96 DNA Methylation-Gold MagPrep integrates DNA denaturation and bisulfite conversion processes into one step followed by a magnetic bead-based clean-up for high-throughput methylation analysis. To streamline the procedure, high temperature is used instead of sodium hydroxide to denature DNA. Desulphonation and clean-up of the converted DNA is performed while bound to the MagBinding Beads. The EZ DNA Methylation-Gold kits have been designed to minimize template degradation, loss of DNA during treatment and clean-up, and to provide complete conversion of unmethylated cytosines. Recovered DNA is ideal for downstream analyses, including PCR amplification, endonuclease digestion, sequencing, microarrays, etc.",
			"handle": "/collections/ez-dna-methylation-gold-kits/products/ez-96-dna-methylation-gold-magprep",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5042_EZ-96-DNA-Methylation-Gold-MagPrep-Kit.jpg?v=1628532384&width=600",
			"generalIndex": "998",
			"id": "ez-96-dna-methylation-gold-magprep",
			"tags": [
				"purified-dna",
				"pcr-qpcr",
				"idt-xgen-methyl-seq",
				"agilent-sureselect-methylseq",
				"beads",
				"high-throughput",
			],
			filters: []
		},
		"dsDNA Shearase Plus": {
			"title": "dsDNA Shearase Plus",
			"catalogNumbers": "E2018-50, E2018-200",
			"description": "dsDNA Shearase Plus is an endonuclease that cleaves phosphodiester bonds in DNA to yield oligonucleotides with 5'-phosphate and 3'-hydroxyl termini. It has a particularly strong preference for dsDNA and generates random-ended DNA fragments of the desired size in a single step. This enzyme is compatible with low volume inputs, thus minimizing sample loss.",
			"handle": "/products/dsdna-shearase-plus",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2018-50_dsDNA-Shearase-Plus-50-U.jpg?v=1628532407&width=600",
			"generalIndex": "998",
			"id": "dsdna-shearase-plus",
			"tags": [
				"low-input",
			],
			filters: []
		},
	}
}